/**
 * 登录注册模块接口列表
 */

import base from './base'; // 导入接口域名列表
import axios from '../utils/http'; // 导入http中创建的axios实例

const article = {
//获取banner
  getBanner() {
    return axios.get(`${base.system}/listBanner`);
  },

  //获取首页产品列表
  listProtype(code) {
    return axios.get(`${base.system}/listProtype?pid=` + (code ? code : 0));
  },
  //获取下载列表
  listDownload() {
    return axios.get(`${base.system}/downList`);
  },
  //获取新品产品列表
  listNewPro() {
    return axios.get(`${base.system}/listPro?isnew=1`);
  },
  listPro(params) {
    return axios.get(`${base.system}/listPro?protype=` + params.protype + '&needProperty=' + params.needProperty);
  },
  listAllPro() {
    return axios.get(`${base.system}/listPro`);
  },
  listAllProLike(name) {
    return axios.get(`${base.system}/listPro?name=`+name);
  },
  listSpecialGroup(params) {
    return axios.get(`${base.system}/proSpecialGroup?productId=`+params.productId+'&groupKey=ww');
  },
  proSpecialDetailById(id) {
    return axios.get(`${base.system}/proSpecialDetail?specialId=`+id);
  },
  proSpecialDetail(params) {
    return axios.get(`${base.system}/proSpecialDetail?productId=`+params.productId+'&specialKey=ww&specialValue='+params.specialValue);
  },
  pageProSpecial(data){
    return axios.post(`${base.system}/pageProSpecial`, data);
  },
  //获取产品列表
  pagePro(data) {
    return axios.post(`${base.system}/pagePro`, data);
  },
  //获取产品详情
  proDetail(id) {
    return axios.get(`${base.system}/proDetail?id=` + id);
  },
  xinlongComond(param) {
    return axios.get(`${base.system}/xinlongComond?productId=` + param.productId+'&width='+param.width);
  },
  //获取产品系列详情
  proTypeDetail(id) {
    return axios.get(`${base.system}/xlproDetail?protype=` + id);
  },
  //获取新闻列表
  newList(params) {
    return axios.get(`${base.system}/news?current=` + params.current + '&pageSize=' + params.pageSize);
  },
};
export default article;
